import { EMPTY_STRING } from '@rotomeca/utils';

/**
 * Options de rendu pour l'item de carte.
 */
export type BnumCardItemRenderOptions = {
	/**
	 * Indique si le slot par défaut doit être affiché.
	 */
	defaultSlot?: boolean;
	/**
	 * Nom du slot à utiliser.
	 */
	slotName?: string;
};

/**
 * Rendu du template de l'item de carte.
 * @param childTemplate Le template du contenu de l'item.
 * @param options Les options de rendu.
 * @returns Le template de l'item de carte.
 */
export function render(
	childTemplate: string,
	options?: BnumCardItemRenderOptions,
) {
	const { defaultSlot = true, slotName = EMPTY_STRING } = options || {};
	const attrs: Record<string, string> = { id: 'defaultslot' };

	if (slotName) attrs['name'] = slotName;

	const slot = defaultSlot ? <slot {...attrs}></slot> : EMPTY_STRING;

	return slot + childTemplate;
}

/**
 * Indique qu'on utilise le slot par défaut.
 */
export const DEFAULT = EMPTY_STRING;
/**
 * Indique qu'on n'utilise pas le slot par défaut.
 */
export const NO_DEFAULT = { defaultSlot: false } as const;
